// C1334 — project.sprints_enabled reader. MySQL TINYINT(1) → 0/1 number, never a real bool.
// Fails OPEN: a null project (both callers .catch() that fetch leg), a missing column
// (pre-054 API), or anything unrecognized reads as enabled — matching migration 054's
// `NOT NULL DEFAULT 1` and settings.js's own truthiness check.
export function sprintsEnabled(project) {
  const v = project && project.sprints_enabled;
  return !(v === 0 || v === false || v === '0');
}

// The sprint a task gets when the sprint field is HIDDEN — the same value the field would
// have pre-selected. `sprints` is GET /sprints order (number DESC), so [0] is the newest.
export function defaultSprintNumber(sprints) {
  return (sprints && sprints.length > 0) ? sprints[0].number : 0;
}
